import { render, staticRenderFns } from "./RelatorioAnalitico.vue?vue&type=template&id=fdfbbd66&scoped=true"
import script from "./RelatorioAnalitico.vue?vue&type=script&lang=js"
export * from "./RelatorioAnalitico.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAnalitico.vue?vue&type=style&index=0&id=fdfbbd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfbbd66",
  null
  
)

export default component.exports